
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import axios from 'axios';
import { decryptResponse, encryptPayload } from './CryptoUtil';
import * as XLSX from 'xlsx';
import { APP_URL } from '../App';


const Report = () => {
  
  const [selectedAction, setSelectedAction] = useState('register');
 
  const [wait, setWait] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const[selectedRegistration,setSelectedRegistration]= useState('');
  const [startdate, setStartdate] = useState('');
  const [enddate, setEnddate] = useState('');
  const [items, setItems] = useState([]);
  const [commanditems, setCommandItems] = useState([]);
  const [showCommandItems, setShowCommandItems] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
const [isViewClicked, setIsViewClicked] = useState(false);






  const handleTabClick = (action) => {
    setSelectedAction(action);
    setIsFormSubmitted(false)
  
    setItems([])
    setCommandItems([])
    // document.getElementById("histroy").reset();

  };

  const handleSubmit=async (e)=>{
    e.preventDefault();

    // setWait(true)
    setWait(false);
//setIsFormSubmitted(true);
setIsViewClicked(false);  // Reset view flag after new submission


    if(startdate > enddate){
      setWait(false)
      return alert("End date cannot be prior to start date")
    }
   
    let payload="";

    if(selectedAction==='register'){
      setShowTable(false);
      payload= encryptPayload({
        "report":selectedAction,
        "startdate":startdate,
        "enddate":enddate,
        "match":selectedRegistration
      })

      
    }else{
      if(selectedAction==="deenroll"){
        setShowTable(false);
      }else{
        setShowTable(true);
      }
      // console.log({
      //   "report":selectedAction,
      //   "startdate":startdate,
      //   "enddate":enddate,       
      // })
      payload=encryptPayload({
        "report":selectedAction,
        "startdate":startdate,
        "enddate":enddate,       
      })
      
    }
    try{
      const response= await axios.post(APP_URL+'downloadReports.php',
        payload ,
        {headers: {
          'Content-Type': 'application/json',
          'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
        
        }})

   
      

      const decryptText = decryptResponse(response.data.payload,response.data.transactionId)
      console.log(decryptText)

    
      if(decryptText.status==="success"){
       
      
        console.log(decryptText.items)
        try{
          let data = decryptText.commanditems
          
          // data = data.map(item => {
          //   // Define a mapping for old commands to new ones
          //   let newCommand;
           
          //   switch (item.command) {
          //     case 'LOCKWALLPAPER':
          //       newCommand = 'SET WALLPAPER';
          //       break;
          //     case 'UNLOCKWALLPAPER':
          //       newCommand = 'REMOVE WALLPAPER';
          //       break;
          //     case 'SETALARM':
          //       newCommand = 'ACTIVATE ALARM';
                
          //       break;
          //     case 'UNSETALARM':
          //       newCommand = 'DEACTIVATE ALARM';
          //       break;
          //     case 'GREYAPP':
          //       newCommand = 'DISABLE APP';
          //       break;
          //     case 'UNGREYAPP':
          //       newCommand = 'RESTORE APP';
          //       break;
          //     default:
          //       newCommand = item.command; // Default case if the command doesn't match
          //   }
          
          //   return { ...item, command: newCommand };
          // });

         








          setCommandItems(data)
          console.log(data)
          setShowCommandItems(true)
          setIsFormSubmitted(true)
        }catch{
          setShowCommandItems(false)
          setCommandItems([])

        }
      }else{
        alert(decryptText.message)
      }
    }catch(error){
      alert("Something went wrong.Please try again in sometime")
    }
    setWait(false)
    
      
    
  }

  const handleFilter=(e)=>{
    setSelectedRegistration(e.target.value)
  }

  const generateExcel=()=>{
    const workbook = XLSX.utils.book_new();
   

    // Convert JSON to worksheet
    
    const worksheet = XLSX.utils.json_to_sheet(items);

    // Append the worksheet to the workbook
   if(selectedAction==="deenroll"){
    XLSX.utils.book_append_sheet(workbook, worksheet, "deenroll");
    
    // Generate the Excel file and trigger a download
    const filename = 'deenroll_record'+'-'+startdate+'-'+enddate+'.xlsx'
    XLSX.writeFile(workbook, filename);

   }else{
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registration Status");
    let found = "Matched"
    
    if(selectedRegistration==="NO"){
      found= "Unmatched"     

    }else if(selectedRegistration==="ALL"){
      found="All"
    }

    // Generate the Excel file and trigger a download
    const filename = 'Registration_Status_'+found+'-'+startdate+'-'+enddate+'.xlsx'
    XLSX.writeFile(workbook, filename);
   } 
  }







  const generateCommandsExcel=()=>{
    const workbook = XLSX.utils.book_new();
   

    // Convert JSON to worksheet
    const newCommandItems = commanditems.map(({ id, ...rest }) => rest);

    const worksheet = XLSX.utils.json_to_sheet(newCommandItems);

    // Append the worksheet to the workbook
  
    XLSX.utils.book_append_sheet(workbook, worksheet, selectedAction+"command");
    let found = selectedAction
    
   


    // Generate the Excel file and trigger a download
    const filename = found+'-'+startdate+'-'+enddate+'.xlsx'
    XLSX.writeFile(workbook, filename);
    
   
   

  }


  const generateBulkUploadExcel=()=>{
    const workbook = XLSX.utils.book_new();
   

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(items);

    // Append the worksheet to the workbook
  
    XLSX.utils.book_append_sheet(workbook, worksheet, "bulkupload");
    let found = selectedAction
    
   


    // Generate the Excel file and trigger a download
    const filename = found+'-bulkUpload-'+startdate+'-'+enddate+'.xlsx'
    XLSX.writeFile(workbook, filename);
    
   
   

  }
  return (
    <div className='row'>
      <div className="col-md-12 col-xl-12 grid-margin stretch-card">
        <div className="card" role="tablist">
          <div className="card-body">
            <h4 className="card-title">Bulk Upload History Details</h4>
            <ul className="nav nav-pills nav-pills-success" id="pills-tab" >
            <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'register' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('register')}
                >
                  Registrations
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'deenroll' ? 'active' : ''}`}
                  id="pills-release-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('deenroll')}
                >
                  De-enrollment/Re-registery Records
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'notify' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('notify')}
                >
                  Enable Notification History
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'setwallpaper' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('setwallpaper')}
                >
                  Set Wallpaper History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'removewallpaper' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('removewallpaper')}
                >
                  Remove Wallpaper History
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'activatealarm' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('activatealarm')}
                >
                  Activate Alarm History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'deactivatealarm' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('deactivatealarm')}
                >
                  Deactivate Alarm History
                </button>
              </li>


            <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'disableapplevel1' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('disableapplevel1')}
                >
                  Disable App Level 1 History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'disableapplevel2' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('disableapplevel2')}
                >
                  Disable App Level 2 History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'restoreapp' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('restoreapp')}
                >
                  Restore App History
                </button>
              </li>
             
             

              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'disablecamera' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('disablecamera')}
                >
                  Disable Camera History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'enablecamera' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('enablecamera')}
                >
                  Enable Camera History
                </button>
              </li>
              
           

{/* 
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'lock' ? 'active' : ''}`}
                  id="pills-lock-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('lock')}
                >
                  Lock  History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'unlock' ? 'active' : ''}`}
                  id="pills-unlock-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('unlock')}
                >
                  Unlock  History
                </button>
              </li> */}
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'Release' ? 'active' : ''}`}
                  id="pills-release-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('Release')}
                >
                  Release Device History
                </button>
              </li>
            
              {/* <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'block' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('block')}
                >
                  Block  History
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link my-1 ${selectedAction === 'unblock' ? 'active' : ''}`}
                  id="pills-notify-tab"
                  data-toggle="pill"
                  onClick={() => handleTabClick('unblock')}
                >
                  Unblock  History
                </button>
              </li> */}
            </ul>
            <div className="tab-content mt-4" id="pills-tabContent">
              <div className='row'>
              <div className="col-md-12 grid-margin transparent">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Download reports </h4>
              <form className="forms-sample" id="histroy" onSubmit={handleSubmit}>
                <div className='row'>
                  <div className="col-sm-4">
                  <div className="form-group">
                 
                  <div className="col-sm-12">
                  <p>StartDate</p>
                  <input type="date" placeholder="startdate"  onChange={(e)=>setStartdate(e.target.value)} className="form-control   input-sm "  required  />
                  
                   
                  </div>
                </div>

                  </div>
                  <div className="col-sm-4">
                      <div className="form-group">
                    
                      <div className="col-sm-12">
                        <p>EndDate</p>
                      <input type="date"  placeholder="Select End Date"  onChange={(e)=>setEnddate(e.target.value)} className="form-control  input-sm "  required  />
                      </div>
                    </div>
                    
                  </div>

                  {selectedAction === 'register'?
                  <div className='col-sm-3'>
                <div className="form-group">
                  
                  <div className="col-sm-12">
                  <p>Select Registration Filter</p>
                  <select className="form-control  input-sm "  required value={selectedRegistration}
                               onChange={handleFilter}>
                      <option value="">----Choose Registration Filter----</option>
                      <option value="ALL">All</option>
                      <option value="YES">Matched</option>
                      <option value="NO">Unmatched</option>
                     
                    </select>
                
                   
                  </div>
                  </div>
                </div>
                :''}

                </div>

                <div className="submit-buttons">
                  <button type="submit" className="btn btn-success me-2 btn-sm text-white" >
                    Submit
                  </button>
                  <button className="btn btn-danger btn-sm text-white" >
                    Cancel
                  </button>
                </div>

                {wait ?
               
                <p>Please wait while we fetch the data </p>
                  :''
                  }
                  
              </form>

              {wait && <p>Please wait while we fetch the data </p>}

{/* {isFormSubmitted && items.length > 0 && ( */}
{isFormSubmitted &&  (
  <div className="mt-3">
    <button
      onClick={
        selectedAction === 'register'
          ? generateExcel
          : generateCommandsExcel
      }
      className="btn btn-info btn-sm text-white me-2"
    >
      Download
    </button>
    <button
      onClick={() => setIsViewClicked(true)}
      className="btn btn-secondary btn-sm text-white"
    >
      View
    </button>
  </div>
)}

              {/* {isViewClicked && items.length > 0 && ( */}
              {isViewClicked  && (
  <>

     { showTable && items.length>0 ?

              <>

              <br></br>
              <hr></hr>

                <h4> Bulk Upload  History </h4>
                <button onClick={generateBulkUploadExcel} className="btn btn-info btn-sm text-white" >
               Click here to Download Bulk Upload History 
             </button>
             <hr></hr>
             <br></br>
              
             <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table className="table table-striped table-borderless">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Date and Time</th>
                        <th>File Name</th>
                        <th>Original File Name</th>
                        <th>Status of File</th>
                        <th>Last Imei</th>
                        <th>Remarks</th>
                        <th>Download</th>
                       
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.date_and_time}</td>
                          <td>{item.file}</td>
                          <td>{item.oldfile}</td>
                          <td>{item.isComplete}</td>
                          <td>{item.lastimei}</td>
                          <td>{item.remarks}</td>
                          <td><a href={'../sbchwebapi/'+selectedAction+'/'+item.file}> Download File</a></td>
                         
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                  
              </>
                
              
              

              :<></>
              
            }
            
{ showCommandItems && commanditems.length>0 ?

            <>
            <br></br>
            <hr></hr>

             <h4> Executed Commands {selectedAction} History : S- Single , A- API , B - Bulk</h4>
             <button onClick={generateCommandsExcel} className="btn btn-info btn-sm text-white" >
               Click here to Download Executed Command History
             </button>
             <hr></hr>
             <br></br>
              <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table table-striped table-borderless">
                  <thead>

                  
                    <tr>
                      <th>S.No.</th>
                      <th>Date and Time</th>
                      <th>IMEI1</th>
                      <th>Transaction ID</th>
                      <th>Interface </th>
                      <th>Command </th>
                      <th>Status </th>
                      <th>User </th>
                      
                      
                     
                    </tr>
                  </thead>
                  <tbody>
                    {commanditems.map((item, index) => (
                      <tr key={item.id +item.transactionId}>
                        <td>{index + 1}</td>
                        <td>{item.date_and_time}</td>
                        <td>{item.imei1}</td>
                        <td>{item.transactionId}</td>
                        <td>{item.interface}</td>
                        <td>{item.command}</td>
                        <td>{item.status}</td>
                        <td>{item.user}</td>
                        
                        
                       
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              
              </>
            
            

            :<></>
            
          }


            {selectedAction ==='register' && items.length>0 ?
            <>
            <br></br>
            <hr></hr>
             
             <button onClick={generateExcel} className="btn btn-info btn-sm text-white" >
               Click here to Download file
             </button>
             <hr></hr>
             <hr /><br/>
           {/* Table Display */}
      <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table table-striped table-borderless">
          <thead>
            <tr>
               <th> Action</th>
              
              <th>S.No.</th>
              <th>IMEI1</th>
              <th>IMEI2</th>
              <th>Match_Status</th>
              <th>Registration_status</th>
              <th>Date and Time</th>
              <th>Manufacturer</th>
              <th>Model</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id+'-'+index}>
                <td><button className="btn btn-info btn-sm text-white"
                   onClick={() => {
                    localStorage.setItem("auditImei", item.imei1);
                    window.location.href = "/auditReport"; // Change to your audit page route
                  }} >View Audit </button></td>
                <td>{index + 1}</td>
                <td>{item.imei1}</td>
                <td>{item.imei2}</td>
                <td>{item.Match_Status}</td>
                <td>{item.Registration_status}</td>
                <td>{item.date_and_time}</td>
                <td>{item.Manufacturer}</td>
                <td>{item.Model}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
            
            </>
            
            
             :         
          ''
              
              
            }

            {selectedAction ==='deenroll' && items.length>0 ?
            <>
            <br></br>
            <hr></hr>
             
             <button onClick={generateExcel} className="btn btn-info btn-sm text-white" >
               Click here to Download De-enroll/Re-register Report
             </button>
             
             <hr /><br/>
           {/* Table Display */}
      <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table table-striped table-borderless">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>IMEI1</th>
              <th>IMEI2</th>
              
              <th>Date and Time</th>
              <th>Action</th>
             
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id+ selectedAction}>
                <td>{index + 1}</td>
                <td>{item.imei1}</td>
                <td>{item.imei2}</td>
                
                <td>{item.date_and_time}</td>
                
                <td>{item.action}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
            
            </>
            
            
             :         
          ''
              
              
            }

  </>
)}

            </div>
          </div>
        </div>

              </div>
        
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
Report.displayName = "Report"
export default Report;
